import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerSementes = styled(motion.div)`
    min-width: 300px;
    width: calc(25% - 10px);
    height: 230px;
    max-height: 230px;
    border-radius: 10px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1000;

    p.ContainerSementes__total {
        font-size: 13px;
        font-weight: 500;
        color: var(--text-color-light);
        letter-spacing: -0.5px;
        margin: 0;
        padding: 0;
        margin-top: -15px;
    }

    div.ContainerSementes__content {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    @media (max-width: 1480px) {
        width: calc(49% - 20px);
    }

    @keyframes treemapEntry {
        0% {
            opacity: 0;
            transform: scale(0);
        }
        70% {
            opacity: 1;
            transform: scale(1.05);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }
`;